import type { MonthCaptionProps } from "react-day-picker";

import { useTranslations } from "@ui/providers/useTranslations";

import styles from "./MonthCaption.module.scss";

export const MonthCaption = (props: MonthCaptionProps) => {
  const { __ } = useTranslations();

  const monthIndex = props.calendarMonth.date.getMonth();
  const year = props.calendarMonth.date.getFullYear();

  return (
    <div className={props.className} style={props.style}>
      <span className={styles.monthName}>{__(`daypicker.month.${monthIndex + 1}`)}</span>
      &nbsp;{year}
    </div>
  );
};
